import { Trans } from "@lingui/macro";

export const ClosedItemWarning = () => (
  <div className="text-gray-600 text-lg">
    <Trans>closed budget item</Trans>
  </div>
);
